<!-- Component for displaying the modal to confirm whether the user want to add a lead in Webportal or create walk-in session in Sales Studio -->
<template>
	<PrecoaModal v-model:open="open">
		<template #default>
			<h2 class="mb-4 text-center font-bold text-slate-900">
				{{ t('home.walkInConfirmation.confirmQuestion') }}
			</h2>
			<div
				class="flex flex-col items-center text-center text-sm text-slate-500"
			>
				{{ t('home.walkInConfirmation.confirmMessage') }}
			</div>
		</template>

		<template #buttons>
			<div class="flex w-full flex-col gap-1">
				<RegularButton
					class="bg-accent-400 text-accent-700 py-2 font-semibold"
					@click="emit('to-web-portal')"
				>
					{{ t('home.walkInConfirmation.createInWebPortal') }}
				</RegularButton>

				<RegularButton
					class="text-primary-600 py-2 font-semibold underline"
					@click="emit('to-sales-studio')"
				>
					{{ t('home.walkInConfirmation.continueInStudio') }}
				</RegularButton>
			</div>
		</template>
	</PrecoaModal>
</template>

<script setup lang="ts">
import PrecoaModal from '@/components/common/PrecoaModal.vue'
import RegularButton from '@/components/forms/RegularButton.vue'
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const open = defineModel<boolean | undefined>('open')

const emit = defineEmits(['to-web-portal', 'to-sales-studio'])
</script>
